{
  "common": {
    "logo_alt": "SparkLayer",
    "return_to_login": "Return to login",
    "generic_error": "A system error occurred, please wait a few minutes and try again."
  },
  "register_page": {
    "heading": "Turn your website into a",
    "heading_highlight": "powerful wholesale solution.",
    "description": "To get started, create an account with SparkLayer. It only takes a minute and we'll then help you set things up!"
  },
  "partner_register_page": {
    "checklist_heading": "Why become a partner?",
    "checklist": {
      "support": {
        "title": "Dedicated partner support",
        "description": "Get quick answers to any SparkLayer related questions so your team is always equipped with the right information."
      },
      "slack": {
        "title": "Exclusive Slack group",
        "description": "Get invited to an exclusive Slack group where you can engage with and get to know our team."
      },
      "sandbox": {
        "title": "Free sandbox test account",
        "description": "Get instant access to a SparkLayer test account where you can try out features and familiarise yourself with how it works."
      }
    },
    "heading": "Access your",
    "heading_highlight": "partner sandbox.",
    "description": "Sign up below to get started."
  },
  "team_member_register_page": {
    "checklist_heading": "Sign up to SparkLayer",
    "checklist": {
      "activate": {
        "title": "Activate B2B ordering",
        "description": "SparkLayer converts your existing website into a powerful B2B solution. Same store. Now with B2B."
      },
      "support": {
        "title": "We're here to support you",
        "description": "Our support team is just a message away, we can even set everything up for you and arrange a call."
      },
      "resources": {
        "title": "Best-practice B2B resources",
        "description": "Get access to our free tried-and-tested tools and tips to enhance your B2B website."
      },
      "sales_team": {
        "title": "Onboard your B2B sales team",
        "description": "Using our Sales Agent tool, let your sales team place orders and manage your B2B customer accounts."
      }
    },
    "heading_highlight": "Activate",
    "heading": "your team invite!",
    "description": "To activate your team invitation, please complete the details below. You'll then get instant access to start collaborating with your team."
  },
  "register_invite_page": {
    "checklist": {
      "enable": {
        "title": "Enable wholesale B2B ordering",
        "description": "Convert your existing website into a wholesale B2B-ready online store."
      },
      "onboarding": {
        "title": "Get up and running quickly",
        "description": "Follow the 5 step onboarding process and get your backend systems and website connected."
      },
      "experience": {
        "title": "Level-up your customer experience",
        "description": "Give your wholesale customers an easy way to order online and to keep track of their orders."
      }
    },
    "heading": "You've been invited",
    "description": "Please register to create an account"
  },
  "enterprise_register_page": {
    "badge": "Enterprise",
    "heading_highlight": "Revolutionize",
    "heading": "the way your B2B customers order from you. Let's begin your onboarding!",
    "description": "To get started, we'll just need you to fill in the form below. You'll then be guided through the setup by our expert onboarding team."
  },
  "forgotten_password_page": {
    "heading": "Password Reset",
    "description": "Please enter your email address to reset your password.",
    "email_label": "Email Address",
    "email_placeholder": "you@yourwebsite.com",
    "submit": "Forgotten Password",
    "rate_limited_error": "Too many password reset requests. Please wait a few minutes and try again."
  },
  "reset_password_page": {
    "heading": "Reset your password",
    "email_label": "Email Address",
    "email_placeholder": "you@yourwebsite.com",
    "password_label": "Password",
    "password_placeholder": "••••••••••••••••",
    "confirm_password_label": "Confirm Password",
    "submit": "Reset Password",
    "success_title": "Your password has been reset",
    "success_message": "Please login to continue",
    "rate_limited_error": "Too many attempts. Please wait a few minutes and try again."
  },
  "two_factor_challenge_page": {
    "heading": "Two-factor authentication",
    "description_code": "Enter the 6-digit code from your authenticator app.",
    "description_recovery": "Enter one of your recovery codes below.",
    "code_label": "Authentication code",
    "code_placeholder": "123456",
    "recovery_code_label": "Recovery code",
    "recovery_code_placeholder": "xxxxxxxxxx-xxxxxxxxxx",
    "submit": "Continue",
    "use_recovery_code": "Use a recovery code instead",
    "use_authentication_code": "Use an authentication code instead",
    "start_again": "Start again",
    "invalid_code_error": "That code was incorrect, or your session has expired.",
    "rate_limited_error": "Too many attempts. Please wait a minute and try again."
  },
  "login_page": {
    "heading": "Sign in to your account",
    "register_prompt": "Or",
    "register_link": "register to start your 14-day free trial",
    "email_label": "Email Address",
    "email_placeholder": "you@yourwebsite.com",
    "password_label": "Password",
    "password_placeholder": "••••••••••••••••",
    "submit": "Sign in",
    "forgot_password": "Forgot your password?",
    "return_to_homepage": "Return to SparkLayer homepage",
    "validation_error": "Please check your details and try again.",
    "rate_limited_error": "Too many login attempts. Please wait a few minutes and try again.",
    "upsell": {
      "badge": "New",
      "more": "More",
      "slide": "Slide {number}",
      "forms": {
        "title": "SparkLayer Forms is here 📋",
        "description": "Build registration forms with built-in approvals."
      },
      "catalogs": {
        "title": "B2B Catalogs has arrived 🛍️",
        "description": "Control which products each customer can see."
      },
      "quoting": {
        "title": "B2B Quoting 🚀",
        "description": "Let customers request and convert quotes."
      },
      "discounts": {
        "title": "B2B Discounts ✨",
        "description": "Drive higher order values with promotions."
      }
    }
  }
}
